import type { FaireProductEntity } from "../../entity_types/product";

export const p_f8d4hrfzh5: FaireProductEntity = {
  token: "p_f8d4hrfzh5",
  type: "product",
  name: "In Dog Years I'm Gay Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/dcc1d4008aa87e212c971e03c3d1877ca8afaa51d995c1ffde2100fe2c9afac8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/85a4e786deb9cb13bfdc008720a071d4c1ab2c8e151ccece35c3f1d1ecd49f2a.jpeg",
    "https://cdn.faire.com/fastly/37d321a0efd7e409e175cd096753f84a09582f05eee87fe4ad06944701f5df70.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/5f4dcd01703c4037401e188040999a81386a324df2533e4d4f2cd2e327317892.jpeg",
    "https://cdn.faire.com/fastly/ba5d362bb3a3fe65beb8d53ee83b0fbdbf2de7e1781720965654a091ca678deb.jpeg"
  ],
  priceDollars: 6.75,
  description: "Limited Availability - Will Not Restock\n\nIf you love dogs and you love being gay, you'll love these socks. We've done the math (hint: it's gay)!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:24.720Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
